import mapboxgl from 'mapbox-gl';
import {library, dom} from '@fortawesome/fontawesome-svg-core';
import {
  faFacebook,
  faTwitter,
  faFacebookSquare,
  faFacebookF,
  faTwitterSquare,
  faInstagram,
  faPinterest,
  faPinterestP,
  faLinkedin,
  faYoutube,
  faPinterestSquare,
  faHouzz,
} from '@fortawesome/free-brands-svg-icons';
import 'slick-carousel';
import 'juxtaposejs/build/js/juxtapose.min'

mapboxgl.accessToken = 'pk.eyJ1IjoiamFzb25jcm9zc2hhdGNoIiwiYSI6ImNqdHVibWM3OTFrZDEzemxsNWE4cHhzYWgifQ.LVeZrTzJ0TomPXruvpCIEg';


export default {
  init() {
    // JavaScript to be fired on all pages
    // FontAwesome init
    library.add( faHouzz, faLinkedin, faYoutube, faFacebook, faTwitter, faFacebookSquare, faFacebookF, faTwitterSquare, faInstagram, faPinterest, faPinterestP, faPinterestSquare);
    dom.watch();
    // /FontAwesome init
  },
  finalize() {

    const sliders = $('.emnari-slick-slider');
    if ( sliders[0] ) {
      sliders.each(function(){
        $(this).slick({
          adaptiveHeight: true,
        });
      });
    }

    const map = $('#map');
    if (map[0]) {

      let mapboxObject = new mapboxgl.Map({
        container: 'map', // container id
        style: 'mapbox://styles/mapbox/streets-v11',
        center: [-71.814513, 42.3671371],
        zoom: 8,
        scrollZoom: false,

      });

      mapboxObject.addControl(new mapboxgl.NavigationControl());

      mapboxObject.on('load', function () {

        $('meta[name="geojson-feature"]').each(function () {

          let feature = JSON.parse($(this).attr("geojson"));

          console.log(feature.geometry.coordinates);

          let popup = new mapboxgl.Popup({ offset: 25 })
            .setHTML("<h5>" + feature.properties.title + "</h5>");


          var el = document.createElement('div');
          el.id = 'marker';

          new mapboxgl.Marker()
            .setLngLat(feature.geometry.coordinates)
            .setPopup(popup)
            .addTo(mapboxObject);
        });

      });

      mapboxObject.on('draw.create', function (e) {
        if (e.features.length && e.features[0].geometry.type == 'Point') {
          let center = e.features[0].geometry.coordinates;

          console.log(center);
          //map.setCenter(center);
          mapboxObject.easeTo({center: center});
        }
      })

    }

    const accordion = $('#accordion');
    if (accordion[0]) {

      $('.accordion-item-link').on('click', function (e) {
        e.preventDefault();

        let $this = $(this);
        $this.parent().toggleClass('active');
        $this.siblings('.accordion-item-content').toggle();
      });
    }

    const tabbedDirectory = $('.tabbed-directories');
    if (tabbedDirectory[0]) {

      $('.tab-directory-button').on('click', function (e) {
        e.preventDefault();

        let $thisButton = $(this);
        let $siblingButtons = $thisButton.parent().parent().find('.tab-directory-button');
        let $thisTabbedDirectorySection = $thisButton.parent().parent().parent();

        $siblingButtons.removeClass('active');
        $thisButton.addClass('active');

        $thisTabbedDirectorySection.find('.tabbed-directory').hide();
        $thisTabbedDirectorySection.find($thisButton.attr('href')).show();

        console.log($thisButton.attr('href'));
      });

    }

    const ctaBoxSections = $('.pb-section-cta_boxes');
    if (ctaBoxSections[0]) {

      $.each(ctaBoxSections, function (key, ctaBoxSection) {
        let ctaBoxHeights = [];
        let ctaBoxes = $(ctaBoxSection).find('.cta-box');

        ctaBoxes.each(function () {
          ctaBoxHeights.push(parseInt($(this).height()));
        });

        $(ctaBoxes).height(Math.max.apply(null, ctaBoxHeights));
      });
    }
  },
};



// WEBPACK FOOTER //
// ./scripts/routes/common.js